/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], (APIFactory, stringResources, ContentActionsProviderAPI) => {
	const visDefsHaveSearchButton = {
		list: true,
		hierarchy2: true,
		hierarchy3: true
	};

	class SearchAction {
		constructor({ features }) {
			this._features = features;
			this._dashboard = features.API;
			this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			features.ContentActions.registerProvider('searchAction', this._api);
		}

		getAPI() {
			return this._api;
		}

		getContentActionList(idList) {
			let contribution = [];
			if(this._getSelectedContent(idList)) {
				const contentId = idList[0];
				const content = this._dashboard.getCanvas().getContent(contentId);
				const searchIcon = this._features['Icons'].getIcon('searchIcon');

				if (this._supportAction(idList, content)) {
					contribution = [{
						name: 'searchAction',
						label:  stringResources.get('search'),
						icon: searchIcon.id,
						section: ContentActionsProviderAPI.ACTION_SECTION.SELECTION_DATA,
						order: 20,
						type: 'NextView',
						viewModule: 'dashboard-analytics/visualizations/search/DataWidgetSearchView',
						viewOptions: {
							height: 50,
							width: 242,
							content: content
						}
					}];
				}
			}

			return contribution;
		}

		_supportAction(idList, content) {
			let isAllowed = false;
			const uiState = this._features['DashboardState'].getUiState();
			const visualization = content.getFeature('Visualization');
			if (visualization && !uiState.eventGroups) {
				let visId = visualization.getDefinition().getId();
				let mappingComplete = visualization.getSlots().isMappingComplete();

				isAllowed = mappingComplete && visDefsHaveSearchButton[visId];
			}

			return isAllowed;
		}

		_getSelectedContent(idList) {
			return idList.length === 1;
		}
	}

	return SearchAction;
});
